import { useCallback, useEffect, useState } from "react";
import { StyleSheet, View, Text, Platform } from "react-native";
import { UAParser } from "ua-parser-js";
import { useI18n } from "../hooks/i18n-hooks";
import { useTheme } from "../hooks/use-theme";
import IconButton from "./IconButton";
import { safeAsyncStorage } from "../utils/safe-async-storage";
import { useIsScreenSizeMin } from "../hooks/useIsScreenSizeMin";

const deviceInfo = new UAParser(window.navigator?.userAgent).getResult();

const IS_RECOMMENDED_BROWSER_WARNING_DISMISSED = "device.isRecommendedBrowserWarningDismissed";

const RecommendedBrowserWarningBar = () => {
    const [isBarShown, setIsBarShown] = useState(false);
    const i18n = useI18n();
    const { colors } = useTheme();
    const styles = useStyles();
    const isLarge = useIsScreenSizeMin("large");

    useEffect(() => {
        void (async () => {
            const isRecommendedBrowserWarningDismissed = await safeAsyncStorage.getItem(
                IS_RECOMMENDED_BROWSER_WARNING_DISMISSED,
            );

            if (
                Platform.OS === "web" &&
                isLarge &&
                !["Safari", "Chrome"].includes(deviceInfo.browser.name || "") &&
                !isRecommendedBrowserWarningDismissed
            ) {
                setIsBarShown(true);
            } else {
                setIsBarShown(false);
            }
        })();
    }, [isLarge]);

    const onDismiss = useCallback(() => {
        setIsBarShown(false);
        void safeAsyncStorage.setItem(IS_RECOMMENDED_BROWSER_WARNING_DISMISSED, "true");
    }, []);

    if (!isBarShown) {
        return null;
    }

    return (
        <View style={styles.appBanner}>
            <Text style={styles.bannerText}>{i18n.t("browser_recommendation")}</Text>
            <IconButton icon="close" iconColor={colors.onWarningBackground} onPress={onDismiss} />
        </View>
    );
};

const useStyles = () => {
    const { fonts, colors } = useTheme();

    return StyleSheet.create({
        appBanner: {
            backgroundColor: colors.warningBorder,
            paddingVertical: 12,
            paddingHorizontal: 16,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
        },
        bannerText: {
            ...fonts.medium,
            textAlign: "center",
            color: colors.onWarningBackground,
            flex: 1,
        },
    });
};

export default RecommendedBrowserWarningBar;
